export const environment = {
    production: false,
    calculation: "https://qual.grit-gnss.eu/calculation",
    navaids: "https://qual.grit-gnss.eu/navaids",
    sectorization_display: "https://qual.grit-gnss.eu/sectorization",
    static_content: "https://qual.grit-gnss.eu/static",
    grit: "https://qual.grit-gnss.eu/grit",
    useB2cAuthentication: false,
    useKeycloakAuthentication: true,
    gritMode:true,
    b2cClientId: 'YOUR_CLIENT_ID',
    b2cGroupClaimValue: "SG_B2C_GRIT_QUAL_USERS",
    enablePreReleaseTools: true,
    keycloakUrl: 'https://qual.grit-gnss.eu/squash',
    keycloakRealm: 'eurocontrol-grit',
    keycloakClientId: 'grit-ui',
    faq_url:"xwiki/bin/view/Frequently%20Asked%20Questions/"

};

